import { useRegistry } from '~/composables/useRegistry';
import { storeLoyaltyStatusForLegacy } from '~/composables/useLoyalty';
import { onUserInit, onKsFlagsReady, onKsFlagsFetched, onAllPassedEventsReady } from '~/events';
import { FETCH_PREFERRED_STORE, FETCH_SDD_MESSAGE } from '#shared/types/actions';
import { GET_ZIP_CODE } from '#shared/types/getters';
import { useNavLoyalty } from '~/stores/navLoyalty';

export default function useUserPreferences() {
  // Run this logic only on the client side to prevent expensive API calls during SSR
  const { isMcom } = useEnvProps();
  const navPreferred = useNavPreferred();
  const navLoyaltyStore = useNavLoyalty();
  const navUser = useNavUser();
  const { fetchRegistries } = useRegistry({ checkUpdates: true });

  const fetchPreferredStore = async () => {
    await navPreferred[FETCH_PREFERRED_STORE]();
    const zipCode = navPreferred[GET_ZIP_CODE];
    if (zipCode) {
      navPreferred[FETCH_SDD_MESSAGE](zipCode);
    }
  };

  const fetchLoyalPoints = () => {
    const isSignedIn = !!navUser.data.isSignedIn;

    if (isSignedIn) {
      navLoyaltyStore.fetchRewardsData();
    } else {
      storeLoyaltyStatusForLegacy({}, isMcom);
    }
  };

  onUserInit(fetchPreferredStore);
  onAllPassedEventsReady([onKsFlagsFetched, onKsFlagsReady, onUserInit], () => {
    fetchRegistries();
    fetchLoyalPoints();
  });
}
